export interface TournamentRanking { 
    playerCurrentEntry:TournamentPlayer;//latest Rank
    playerTopEntry:TournamentPlayer;//Best Rank 
    entries:Array<TournamentPlayer>;//All Rankings
    totalNumberOfEntries:number,
    numberOfPages:number,
    page:number,


}
//--old
// export interface TournamentPlayer { 
//     position:number;
//     displayName:string;
//     score:number;
//     prize:{
//         amount:number;
//         currency:string;
//     };
// }
//-new

export interface TournamentPrize
{
    // amount:number;
    // currency:string;

    monetaryPrize:{
        amount:number;
        currency:string
    };
    nonMonetaryPrize:string//name of the item
    

}
export interface TournamentPlayer { 
    position:number;
    displayName:string;
    score:number;
    prize:TournamentPrize;
    isCurrentUserEntry:boolean;
}

///--

export interface TournamentParticipation { 
    tournamentId: number,
    state: string,
    score: number,
}


export interface TournamentRegisterResponse
{
  tournamentId: number,
  tournamentParticipationScore: number,
  tournamentParticipationState: string; //"ACTIVE"
  tournamentParticipationBalance:
  {
    amount:number;
    currency:number;
  }
}
export enum AllowedActionsTournament { NONE = "NONE", BUY_IN = "BUY_IN", REBUY = "REBUY" , PLAY = "PLAY" };

export interface allowedTournamentAction
{
    NONE:AllowedActionsTournament.NONE;
    BUY_IN:AllowedActionsTournament.BUY_IN;
    REBUY:AllowedActionsTournament.REBUY;
    PLAY:AllowedActionsTournament.PLAY;
}

export enum TournamentState { ACTIVE= "ACTIVE" , FINISHED = "FINISHED", SCHEDULED ="SCHEDULED" };
export interface TournamentInfosData
{
 //-old
//   participated: boolean,
//   allowedToRegister: boolean,
 //new

 allowedAction:AllowedActionsTournament;
  maxNumberOfRebuys: number,
numberOfRebuysLeft: number,
  buyInPrice: { amount: number, currency: string },
  rebuyPrice: { amount: number, currency: string },
  ranking:number;
  tournamentState:TournamentState.ACTIVE|TournamentState.FINISHED|TournamentState.SCHEDULED;
}